import React from 'react';

import { Field, Form, Formik } from 'formik';
import PropTypes from 'prop-types';

// import classes from '@/components/Reactivation/style.module.scss';

const ReactivationComponent = ({ error, handleSubmit, validationSchema, intl }) => (
  <div className="flex flex-col">
    <h3 className="text-[1.25em] font-bold text-[#393939] mb-6">
      {intl.formatMessage({ id: 'REACTIVATE_ORDER' })}
    </h3>
    <Formik initialValues={{ reason: '' }} onSubmit={handleSubmit} validationSchema={validationSchema}>
      {({ errors, isSubmitting }) => (
        <Form className="flex flex-col space-y-5">
          <div className="flex flex-col px-0">
            <label htmlFor="reason" className="text-[0.75rem] font-bold uppercase text-[#393939] mb-1">
              {intl.formatMessage({ id: 'REASON' })}
            </label>
            <Field
              name="reason"
              id="reason"
              as="textarea"
              className="h-[6em] p-2 border border-[#e3e3e3] rounded-[3px] bg-white font-sans text-[0.875rem] font-semibold text-[#919191] focus:outline-none focus:border-[#4d8fca] transition-colors resize-none"
            />
            {(error || errors.reason) && (
              <div className="mt-2 text-[0.87rem] text-[#ed0000]">
                {error || errors.reason}
              </div>
            )}
          </div>
          <div className="flex justify-end items-center mt-6">
            <button
              className="group relative inline-flex items-center justify-center min-w-[140px] h-[36px] px-[1.2rem] border-0 rounded-[3px] bg-[#97a500] text-white text-[0.9375rem] font-bold leading-[1.4] transition-opacity hover:opacity-75 disabled:cursor-not-allowed"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <div className="absolute inset-0 flex items-center justify-center bg-white/80 rounded-[3px]">
                   <div className="w-[18px] h-[18px] border-2 border-black/15 border-r-black/40 rounded-full animate-spin"></div>
                </div>
              ) : (
                intl.formatMessage({ id: 'SEND' })
              )}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  </div>
);

ReactivationComponent.propTypes = {
  error: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  validationSchema: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
};

ReactivationComponent.defaultProps = {
  error: null,
};

export default ReactivationComponent;
